import { LicenseStates } from '../../../js/utils/local-data';

export interface UsStateOption {
  value: string;
  label: string;
}

/**
 * US state filter options.
 *
 * Sourced from the shared `LicenseStates` map (50 states + DC + VI) — the same
 * operational set used for provider licensing, which mirrors the backend
 * `LICENSE_STATE_CHOICES` used by the Opportunity `state` filter. This excludes
 * armed-forces codes (AA/AE/AP) and non-VI territories. Sorted by label.
 */
export function getUsStateOptions(): UsStateOption[] {
  return Object.entries(LicenseStates)
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
